module.exports = __webpack_public_path__ + "static/media/cabin-air-filters-mr-card-front.29410eb5.jpeg";